var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3279 0C8.56693 0 6.87821 0.699515 5.63327 1.94463C4.38815 3.18975 3.68863 4.87864 3.68863 6.63924V10.3278H2.95087C2.16819 10.3278 1.41774 10.6388 0.86436 11.1922C0.310852 11.7456 0 12.4962 0 13.2789V20.6561C0 21.4386 0.310812 22.1892 0.86436 22.7426C1.41774 23.296 2.16814 23.6069 2.95087 23.6069H17.7052C18.4879 23.6069 19.2384 23.296 19.7917 22.7426C20.3453 22.1892 20.6561 21.4386 20.6561 20.6561V13.2789C20.6561 12.4962 20.3453 11.7456 19.7917 11.1922C19.2384 10.6388 18.488 10.3278 17.7052 10.3278H16.9675V6.63924C16.9675 4.87847 16.268 3.18958 15.0228 1.94463C13.7777 0.699515 12.089 0 10.3282 0H10.3279ZM13.2787 10.3281H7.37696V6.63946C7.37696 5.58523 7.93943 4.61113 8.85231 4.08402C9.76537 3.5569 10.8903 3.5569 11.8033 4.08402C12.7162 4.61113 13.2787 5.58527 13.2787 6.63946L13.2787 10.3281Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9bd21c0e8f0bb2c78ec9aa50bdeec093.svg";
export { ForwardRef as ReactComponent };